import React from 'react';
import { localise } from '../../../../services/lang/lang';
import StandardModal from '../../Modal/StandardModal';
import { useUnsavedChanges } from '../../UnsavedChanges/UnsavedChangesProvider';
import AddContactWrapper from './AddContactWrapper';
const AddContactModal = ({ inspectionId, onAddContact, onClose, ...rest }) => {
    const { attemptNavigate } = useUnsavedChanges();
    return (React.createElement(StandardModal, { "data-testid": "add_contact_modal", variant: "primary", title: localise('ADD_CONTACT'), onClose: () => attemptNavigate(onClose), ...rest },
        React.createElement(AddContactWrapper, { variant: "add", inspectionId: inspectionId, onAddContact: onAddContact })));
};
export default AddContactModal;
